export default __webpack_public_path__ + "static/media/pathicon.3b47d6f4.webp";